module.exports = __webpack_public_path__ + "img/index-10.895c8513.png";